import React, { useRef, useEffect } from 'react';
import { ButtonCommon } from 'components/common';
import { FileArrowUp, Download, FileArrowDown } from '@phosphor-icons/react';
import { ExcelSubmenuProps } from 'types';
// Define the handlers for each menu item

const ExcelSubmenu: React.FC<ExcelSubmenuProps> = ({ isVisible, onClose, handlers }) => {
  const menuRef = useRef<HTMLDivElement>(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (isVisible) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isVisible, onClose]);

  if (!isVisible) {
    return null;
  }

  return (
    <div
      ref={menuRef}
      className='bg-white rounded-lg shadow-lg border border-gray-100 p-3 pt-0 min-w-max'
      onClick={(e) => e.stopPropagation()}
    >
      <div className='flex flex-col py-2 gap-1 w-full'>
        {handlers.onExportTemplate && (
          <ButtonCommon
            onClick={() => {
              handlers.onExportTemplate?.();
              onClose();
            }}
            color='outline'
            size='sm'
            radius='rounded'
            icon={<FileArrowUp size={20} />}
            className='mt-[8px] !text-[14px] w-full !justify-start hover:bg-[var(--textBlack8)] !border-none'
          >
            <span>Tệp Excel Mẫu</span>
          </ButtonCommon>
        )}

        {handlers.onImport && (
          <ButtonCommon
            onClick={() => {
              handlers.onImport?.();
              onClose();
            }}
            color='outline'
            size='sm'
            radius='rounded'
            icon={<FileArrowUp size={20} />}
            className='mt-[8px] !text-[14px] w-full !justify-start hover:bg-[var(--textBlack8)] !border-none'
          >
            <span>Nhập Tệp Excel</span>
          </ButtonCommon>
        )}

        {handlers.onExport && (
          <ButtonCommon
            onClick={() => {
              handlers.onExport?.();
              onClose();
            }}
            color='outline'
            size='sm'
            radius='rounded'
            icon={<FileArrowDown size={20} />}
            className='mt-[8px] !text-[14px] w-full !justify-start hover:bg-[var(--textBlack8)] !border-none'
          >
            <span>Xuất Tệp Excel</span>
          </ButtonCommon>
        )}

        {/* {handlers.onExportByView && (
          <ButtonCommon
            onClick={() => {
              handlers.onExportByView?.();
              onClose();
            }}
            color='outline'
            size='sm'
            radius='rounded'
            icon={<DownloadSimple size={20} />}
            className='mt-[8px] !text-[14px] w-full !justify-start hover:bg-[var(--textBlack8)] !border-none'
          >
            <span>Xuất Excel Theo Chế Độ Xem</span>
          </ButtonCommon>
        )} */}

        {handlers.onExportByFilter && (
          <ButtonCommon
            onClick={() => {
              handlers.onExportByFilter?.();
              onClose();
            }}
            color='outline'
            size='sm'
            radius='rounded'
            icon={<Download size={20} />}
            className='mt-[8px] !text-[14px] w-full !justify-start hover:bg-[var(--textBlack8)] !border-none'
          >
            <span>Xuất Tệp Excel Theo Bộ Lọc</span>
          </ButtonCommon>
        )}
      </div>
    </div>
  );
};

export default ExcelSubmenu;
